import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axiosClient from "../../axios-client";
 

export const sendOtpPaymentSetting = createAsyncThunk(
  "payment/sendOtpPaymentSetting",
  async ({ email, countryCode, phone }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        "/otp/sendOtpPaymentSetting",
        {},
        {
          params: {
            Email: email,
            CountryCode: countryCode,
            Phone: phone,
          },
        },
      );

      return {
        statusCode: response.data?.statusCode,
        message: response.data?.message,
        data: response.data?.data || null,
      };
    } catch (err) {
      const message =
        err.response?.data?.message ||
        err.message ||
        "Failed to send OTP for payment settings";
      return rejectWithValue(message);
    }
  },
);

export const verifyOtpPaymentSetting = createAsyncThunk(
  "payment/verifyOtpPaymentSetting",
  async ({ email, otp, key = "payment_setting_otp" }, { rejectWithValue }) => {
    try {
      const response = await axiosClient.post(
        "/otp/verifyOtpPaymentSetting",
        {},
        {
          params: {
            Email: email,
            Otp: otp,
            Key: key,
          },
        },
      );

      return {
        statusCode: response.data?.statusCode,
        message: response.data?.message,
        data: response.data?.data || null,
      };
    } catch (err) {
      const message =
        err.response?.data?.message || err.message || "Invalid or expired OTP";
      return rejectWithValue(message);
    }
  },
);

const initialState = {
  featureService: null,
  selectedService: null,
  message: null,
  reqPhone: null,
  offerAmount: null,
  totalPrice: null,
  finalPrice: null,
  featureAmount: null,
  paymentType: "",

  otpLoading: false,
  otpError: null,
  otpSuccess: false,

  verifyLoading: false,
  verifyError: null,
  verifySuccess: false,
};

const PaymentSlice = createSlice({
  name: "payment",
  initialState,
  reducers: {
    resetPaymentState: (state) => initialState,

    setFeatureService: (state, action) => {
      state.featureService = action.payload;
    },
    setSelectedService: (state, action) => {
      state.selectedService = action.payload;
    },
    setMessage: (state, action) => {
      state.message = action.payload;
    },
    setReqPhone: (state, action) => {
      state.reqPhone = action.payload;
    },
    setOfferAmount: (state, action) => {
      state.offerAmount = action.payload;
    },
    setTotalPrice: (state, action) => {
      state.totalPrice = action.payload;
    },
    setFinalPrice: (state, action) => {
      state.finalPrice = action.payload;
    },
    setFeatureAmount: (state, action) => {
      state.featureAmount = action.payload;
    },
    setPaymentType: (state, action) => {
      state.paymentType = action.payload;
    },

    resetOtpState: (state) => {
      state.otpLoading = false;
      state.otpError = null;
      state.otpSuccess = false;
      state.verifyLoading = false;
      state.verifyError = null;
      state.verifySuccess = false;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(sendOtpPaymentSetting.pending, (state) => {
        state.otpLoading = true;
        state.otpError = null;
        state.otpSuccess = false;
      })
      .addCase(sendOtpPaymentSetting.fulfilled, (state) => {
        state.otpLoading = false;
        state.otpSuccess = true;
      })
      .addCase(sendOtpPaymentSetting.rejected, (state, action) => {
        state.otpLoading = false;
        state.otpSuccess = false;
        state.otpError = action.payload;
      })

      .addCase(verifyOtpPaymentSetting.pending, (state) => {
        state.verifyLoading = true;
        state.verifyError = null;
        state.verifySuccess = false;
      })
      .addCase(verifyOtpPaymentSetting.fulfilled, (state) => {
        state.verifyLoading = false;
        state.verifySuccess = true;
      })
      .addCase(verifyOtpPaymentSetting.rejected, (state, action) => {
        state.verifyLoading = false;
        state.verifySuccess = false;
        state.verifyError = action.payload;
      });
  },
});

export const {
  resetPaymentState,
  setFeatureService,
  setTotalPrice,
  setFinalPrice,
  setSelectedService,
  setMessage,
  setReqPhone,
  setOfferAmount,
  setFeatureAmount,
  setPaymentType,
  resetOtpState,
} = PaymentSlice.actions;

export default PaymentSlice.reducer;
